module.exports = __webpack_public_path__ + "img/buildyourown_v5.083f55f.svg";